import { render, staticRenderFns } from "./OwnerMemberStep.vue?vue&type=template&id=1b5c75c2&scoped=true&"
import script from "./OwnerMemberStep.vue?vue&type=script&lang=ts&"
export * from "./OwnerMemberStep.vue?vue&type=script&lang=ts&"
import style0 from "./OwnerMemberStep.vue?vue&type=style&index=0&id=1b5c75c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5c75c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VSpacer,VTextField})
